<i18n lang='yml' src='../i18n/ContainerTrainingAgreementManagement.yml'></i18n>

<template>
  <div>
    <div class="heading-block d-flex">
      <h4>{{ $t('manage_candidates') }}</h4>
      <a :href="new_training_agreement_path" class="btn btn-sm btn-success ml-auto">
        <font-awesome-icon :icon="['fa', 'save']"/>
        {{ $t('create') }}
      </a>
    </div>
    <h5 class="heading-page">{{ $t('view_candidates') }}</h5>
    <p class="border-bottom">{{ $t('view_candidates_details') }}</p>
   <div class="col-md-12 mt-auto">
    
    </div>
    <h4 v-if="error">{{ $t('loading_error') }}</h4>
    <div v-else class="media-list">
      <div class="media" v-for="(cta, i) in containerTrainingAgreements" :key="i">
        <div class="media-body">
          <div class="action-bar">
            <h4>
              {{cta.user_identity.first_name}} {{cta.user_identity.last_name}} - {{cta.user_identity.email}} - 
              <a :href="`container_training_agreements/${cta.id}/edit`"> {{cta.training_program_name}} </a>
              <template v-if="cta.status == 'active'"> - {{$t('active')}} </template>
              <template v-else> - {{$t('inactive')}} </template>
            </h4>
            <div class="btn-group btn-group-xs ml-auto" role="group">
              <a class="btn btn-sm btn-outline-primary" :href="`container_training_agreements/${cta.id}/edit`">
                <font-awesome-icon :icon="['fa', 'pencil-alt']" />
                {{ $t('edit') }}
              </a>
              <a class="btn btn-sm btn-outline-danger" :data-confirm="$t('confirm_delete')" data-method="delete" :href="`container_training_agreements/${cta.id}`">
                <font-awesome-icon :icon="['fa', 'trash-alt']" />
                {{ $t('delete_cta') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['locale', 'new_training_agreement_path', 'container_training_agreements'],
  data() {
    return {
      trainingAgreement: null,
      containerTrainingAgreements: [],
      error: false,
    }
  },
  mounted() {
    this.$i18n.locale = this.locale;
    try{
      this.containerTrainingAgreements = JSON.parse(this.container_training_agreements)
    }
    catch(err) {
      console.log("Error Loading training Agreements")
      this.error = true
    }
  },
}
</script>
